import React, { useState, useEffect } from 'react';

function TermsEnforcementModal({ termsText, onAccept }) {
    const [scrolledToBottom, setScrolledToBottom] = useState(false);
    
    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollHeight - scrollTop <= clientHeight + 50) {
            setScrolledToBottom(true);
        }
    };
    
    useEffect(() => {
         const element = document.getElementById('terms-scroll-area');
         if (element && element.scrollHeight <= element.clientHeight) {
             setScrolledToBottom(true);
         }
    }, [termsText]);

    return (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-90 z-[100] flex items-center justify-center p-4">
            <div className="bg-white rounded-lg shadow-2xl max-w-2xl w-full flex flex-col max-h-[90vh]">
                <div className="p-6 border-b border-gray-200">
                    <h2 className="text-2xl font-bold text-red-600">Updated Terms & Conditions</h2>
                    <p className="text-gray-600 mt-2 text-sm">
                        Please review and accept the updated Terms and Conditions to continue using Shep's Sniff Spot.
                    </p>
                </div>
                
                <div 
                    id="terms-scroll-area"
                    onScroll={handleScroll}
                    className="flex-grow overflow-y-auto p-6 bg-gray-50 text-sm leading-relaxed whitespace-pre-wrap border-b border-gray-200"
                >
                    {termsText || "Loading terms..."}
                </div>
                
                <div className="p-6 bg-white flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-xs text-gray-500 italic">
                        {scrolledToBottom ? "Thank you for reviewing." : "Please scroll to the bottom to accept."}
                    </p>
                    <button
                        onClick={onAccept}
                        className={`px-8 py-3 rounded-lg font-bold text-white transition shadow-lg ${
                            scrolledToBottom 
                            ? 'bg-blue-600 hover:bg-blue-700 transform hover:scale-105' 
                            : 'bg-blue-600 hover:bg-blue-700'
                        }`}
                    >
                        I Agree to Terms
                    </button>
                </div>
            </div>
        </div>
    );
}
export default TermsEnforcementModal;
